// Module
var code = "<md-icon md-svg-icon=\"{{$ctrl.icon || 'BOX'}}\" class=\"bringoz-icon-16\" ng-class=\"$ctrl.isMissingPackage ? 'missing-items' : $ctrl.packingDisplayStatus\"> <md-tooltip ng-if=\"!$ctrl.name\">{{$ctrl.name}}</md-tooltip> </md-icon> ";
// Exports
export default code;